// eslint-disable-next-line import/prefer-default-export
export const DARK_PALETTE = {
  background: "#0B1220",
  backgroundSecondary: "#151D2E",
  backgroundTertiary: "#1E293B",
  surface: "#1C2640",
  surfaceSecondary: "#243152",
  surfaceTertiary: "#2D3D63",
  text: "#F1F5F9",
  textSecondary: "#CBD5E1",
  textTertiary: "#94A3B8",
  border: "#334155",
  borderLight: "#475569",
  borderDark: "#1E293B",
  primary: "#A78BFA",
  primaryLight: "#C4B5FD",
  accent: "#F472B6",
} as const;
